// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3eE7C","requiredAsterisk":"Info_requiredAsterisk__2wdiu"};